import React, { useState, useEffect } from 'react';
import { navItems, profileData } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';
import LanguageToggle from './LanguageToggle';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ activeSection, onNavigate }) => {
  const { language } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionId) => {
    onNavigate(sectionId);
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="brand">
        <div className="brand-avatar">
          <img src={profileData.photo} alt="Avatar" />
        </div>
        <div className="brand-text">
          <strong>{profileData.name} {profileData.lastName}</strong>
          <span>{profileData.title[language]}</span>
        </div>
      </div>

      {/* Desktop Navigation */}
      <nav className="desktop-nav">
        {navItems.map((item) => (
          <a
            key={item.id}
            onClick={() => handleNavClick(item.id)}
            className={activeSection === item.id ? 'active' : ''}
          >
            {item.label[language]}
          </a>
        ))}
        <LanguageToggle />
      </nav>

      {/* Mobile Menu Button */}
      <div className="mobile-controls">
        <LanguageToggle />
        <Button
          variant="ghost"
          size="icon"
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </Button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <nav className="mobile-nav">
          {navItems.map((item) => (
            <a
              key={item.id}
              onClick={() => handleNavClick(item.id)}
              className={activeSection === item.id ? 'active' : ''}
            >
              {item.icon} {item.label[language]}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
